import { Avatar, Tooltip, Popover, Button } from "@mui/material";
import CommonUtil from "@/util/CommonUtils";
import { useState, useEffect } from "react";
import IconHandaler from "@/components/IconHandaler";
import AccessControl from "@/components/AccessControl";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import {REACT_PERSON_MANAGER_ADD} from "@/router/ReactEndPoints";


export const getColumns = (t, selectEventType, handleActions) => {
  let columns = [];
  if (selectEventType === 1) {
    columns.push(
      {
        field: "CountryName",
        headerName: t("LVLLOC0001"),
        flex: 1,
        headerAlign: "center",
        align: "center",
        sortable: false,
        renderCell: (e) => (
          <Tooltip title={e.row.name} arrow placement="bottom">
            <span>{CommonUtil.formatLongText(e.row.name)}</span>
          </Tooltip>
        ),
      },
      {
        field: "CountryCode",
        headerName: t("LVLRC0020"),
        flex: 1,
        sortable: false,
        headerAlign: "center",
        align: "center",
        renderCell: (e) => (
          <Tooltip title={e.row.code} arrow placement="bottom">
            <span>{CommonUtil.formatLongText(e.row.code)}</span>
          </Tooltip>
        ),
      }
    );
  }

  if (selectEventType === 2) {
    columns.push(
      {
        field: "StateName",
        headerName: t("LVLLOC0008"),
        flex: 1,
        headerAlign: "center",
        align: "center",
        sortable: false,
        renderCell: (e) => (
          <Tooltip title={e.row.name} arrow placement="bottom">
            <span>{CommonUtil.formatLongText(e.row.name)}</span>
          </Tooltip>
        ),
      },
      {
        field: "StateCode",
        headerName: t("LVLLOC0009"),
        flex: 1,
        sortable: false,
        headerAlign: "center",
        align: "center",
        renderCell: (e) => (
          <Tooltip title={e.row.code} arrow placement="bottom">
            <span>{CommonUtil.formatLongText(e.row.code)}</span>
          </Tooltip>
        ),
      },
      {
        field: "CountryName",
        headerName: t("LVLLOC0001"),
        flex: 1,
        sortable: false,
        headerAlign: "center",
        align: "center",
        renderCell: (e) => {
          return (
            <Tooltip title={e.row?.countryVO?.name} arrow placement="bottom">
              <span>{CommonUtil.formatLongText(e.row?.countryVO?.name)}</span>
            </Tooltip>
          );
        },
      }
    );
  }

  if (selectEventType === 3) {
    columns.push(
      {
        field: "CityName",
        headerName: t("LVLLOC0015"),
        flex: 1,
        headerAlign: "center",
        align: "center",
        sortable: false,
        renderCell: (e) => (
          <Tooltip title={e.row.name} arrow placement="bottom">
            <span>{CommonUtil.formatLongText(e.row.name)}</span>
          </Tooltip>
        ),
      },
      {
        field: "CityCode",
        headerName: t("LVLLOC0016"),
        flex: 1,
        sortable: false,
        headerAlign: "center",
        align: "center",
        renderCell: (e) => (
          <Tooltip title={e.row.code} arrow placement="bottom">
            <span>{CommonUtil.formatLongText(e.row.code)}</span>
          </Tooltip>
        ),
      },
      {
        field: "StateName",
        headerName: t("LVLLOC0008"),
        flex: 1,
        sortable: false,
        headerAlign: "center",
        align: "center",
        renderCell: (e) => {
          return (
            <Tooltip title={e.row?.stateVO?.name} arrow placement="bottom">
              <span>{CommonUtil.formatLongText(e.row?.stateVO?.name)}</span>
            </Tooltip>
          );
        },
      }
    );
  }

  if (selectEventType === 4) {
    columns.push(
      {
        field: "OutletType",
        headerName: t("LVLOT0004"),
        flex: 1,
        headerAlign: "center",
        align: "center",
        sortable: false,
        renderCell: (e) => (
          <Tooltip title={e.row.name} arrow placement="bottom">
            <span>{CommonUtil.formatLongText(e.row.name)}</span>
          </Tooltip>
        ),
      },
      {
        field: "OutletCode",
        headerName: t("LOCATION10"),
        flex: 1,
        sortable: false,
        headerAlign: "center",
        align: "center",
        renderCell: (e) => (
          <Tooltip title={e.row.code} arrow placement="bottom">
            <span>{CommonUtil.formatLongText(e.row.code)}</span>
          </Tooltip>
        ),
      },
      {
          headerName: `${t("LVLRC0010")}`,
              flex: 1,
          headerAlign: "center",
          align: "center",
          renderCell: (e) => (
          <IconHandaler>
              <AccessControl authorization={"1048"}>
                  <Tooltip title={t("LVLDB0021")} sx={{pl: 1}}>
                      <EditIcon
                          onClick={() => handleActions("EditOutletType", e)}
                          style={{
                              alignSelf: "center",
                              paddingTop: "0px",
                              paddingLeft: "5px",
                              opacity: "1",
                              fontSize: "20px",
                              color: "#A2A3A3",
                          }}
                      />
                  </Tooltip>
              </AccessControl>

              <AccessControl authorization={"1048"}>
                  <Tooltip title={t("LVLDB0022")} sx={{pl: 1}}>
                      <DeleteIcon
                          onClick={() => handleActions("DeleteOutletType", e.row.id)}
                          style={{
                              alignSelf: "center",
                              paddingTop: "0px",
                              paddingLeft: "5px",
                              opacity: "1",
                              fontSize: "20px",
                              color: "#A2A3A3",
                          }}
                      />
                  </Tooltip>
              </AccessControl>

          </IconHandaler>
      ),
      },
    );
  }

  if (selectEventType === 5) {
    columns.push(
      {
        field: "name",
        headerName: t("LOCATION11"),
        flex: 1,
        headerAlign: "center",
        align: "center",
        sortable: false,
        renderCell: (e) => {
          return (
            <Tooltip title={e.row.name} arrow placement="bottom">
              <span>{CommonUtil.formatLongText(e.row.name)}</span>
            </Tooltip>
          );
        },
      },
      {
        field: "code",
        headerName: t("LOCATION12"),
        flex: 1,
        sortable: false,
        headerAlign: "center",
        align: "center",
        renderCell: (e) => (
          <Tooltip title={e.row.code} arrow placement="bottom">
            <span>{CommonUtil.formatLongText(e.row.code)}</span>
          </Tooltip>
        ),
      },
        {
            headerName: `${t("LVLRC0010")}`,
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (e) => (
                <IconHandaler>
                    <AccessControl authorization={"1048"}>
                        <Tooltip title={t("LVLDB0021")} sx={{pl: 1}}>
                            <EditIcon
                                onClick={() => handleActions("EditCityZone", e)}
                                style={{
                                    alignSelf: "center",
                                    paddingTop: "0px",
                                    paddingLeft: "5px",
                                    opacity: "1",
                                    fontSize: "20px",
                                    color: "#A2A3A3",
                                }}
                            />
                        </Tooltip>
                    </AccessControl>

                    <AccessControl authorization={"1048"}>
                        <Tooltip title={t("LVLDB0022")} sx={{pl: 1}}>
                            <DeleteIcon
                                onClick={() => handleActions("DeleteCityZone", e.row.id)}
                                style={{
                                    alignSelf: "center",
                                    paddingTop: "0px",
                                    paddingLeft: "5px",
                                    opacity: "1",
                                    fontSize: "20px",
                                    color: "#A2A3A3",
                                }}
                            />
                        </Tooltip>
                    </AccessControl>

                </IconHandaler>
            ),
        },
    );
  }
  return columns;
};
